import { gql } from '@apollo/client';

export const GET_PAGINATED_ORDER_ITEMS = gql`
  query v2FindAndCountOrderItems(
    $take: Int = 25
    $skip: Int = 0
    $where: V2OrderItemWhereInput
  ) {
    v2FindAndCountOrderItems(
      take: $take
      skip: $skip
      where: $where
      orderBy: { createdAt: desc }
    ) {
      count
      orderItems {
        id
        order {
          id
          orderNumber
          orderType {
            name
          }
        }
        orderItemNumber
        inboundOrderItemId
        serialNumber
        asset {
          id
          assetNumber
          make
          model
        }
        shipment {
          status
          substatus
          substatusDescription
          shipmentCarrierId
          trackings {
            id
            trackingNumber
            trackingLink
            expectedDeliveryDate
          }
        }
        shipmentItems {
          shipmentId
          shipment {
            trackings {
              id
              trackingNumber
              trackingLink
              expectedDeliveryDate
            }
            shipmentCarrierId
            status
            substatus
            substatusDescription
          }
          createdAt
        }
        productVariant {
          sku
          productId
          product {
            name
          }
          productVariantAttributes {
            value
            name
          }
        }
      }
    }
  }
`;

export const GET_SHIPMENT_CARRIERS = gql`
  query getShipmentCarriers {
    getShipmentCarriers {
      items {
        id
        name
      }
    }
  }
`;
